import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { log } from 'console';
import { Swal2Service } from 'src/app/services/swal2.service';
import { UserService } from 'src/app/services/user.service';
import { securePassword } from 'src/app/utils/patterns';

@Component({
  selector: 'app-new-user-master',
  templateUrl: './new-user-master.component.html',
  styleUrls: ['./new-user-master.component.css']
})
export class NewUserMasterComponent implements OnInit {

  title: string = 'Nuevo usuario maestro';
  newUserMasterForm: FormGroup = this.fb.group({
    name: ['', Validators.required],
    lastName: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.pattern(securePassword)]],
    // rol: [1],
  });

  hidePassword: boolean = true;
  loader: boolean = false;
  
  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private swal: Swal2Service,
    private dialogRef: MatDialogRef<NewUserMasterComponent>,
  ) { 
    
  }

  ngOnInit() {
  }

  onSubmit() {
    console.log(this.newUserMasterForm.value);
    if (this.newUserMasterForm.invalid) {
      this.newUserMasterForm.markAllAsTouched();
      return;
    }

    this.loader = true;
    const formData = new FormData();
    formData.append('name', this.newUserMasterForm.get('name')?.value + ' ' + this.newUserMasterForm.get('lastName')?.value);
    formData.append('email', this.newUserMasterForm.get('email')?.value);
    formData.append('password', this.newUserMasterForm.get('password')?.value);
    // formData.append('roles[]', this.newUserMasterForm.get('rol')?.value);
    this.userService.create(formData).subscribe({
      next: (res: any) => {
        this.loader = false;
        this.swal.showToast('Usuario creado correctamente', 'success');
        // this.newUserMasterForm.reset();
        this.dialogRef.close(res);
      },
      error: (err: any) => {
        this.swal.showToast(err?.error?.message || 'Algo salió mal', 'error');
        this.loader = false;
      }
    });
  }

}
